import {
  CONDITION_CMPS,
  EQUALITY_CMPS,
  isBooleanTagType,
  isNumericTagType,
  isStringTagType,
  type ConditionCmp,
  type ConditionScalar
} from '@axilon-apps/domains-ontology-ui-state'

export type LiveValueKind = 'number' | 'string' | 'boolean'

export function liveValueKind(tagType: string | undefined, value: ConditionScalar): LiveValueKind {
  if (isBooleanTagType(tagType)) return 'boolean'
  if (isStringTagType(tagType)) return 'string'
  if (isNumericTagType(tagType)) return 'number'
  if (typeof value === 'boolean') return 'boolean'
  if (typeof value === 'string') return 'string'
  return 'number'
}

export function parseLiveInput(raw: string): ConditionScalar {
  const trimmed = raw.trim()
  if (trimmed === 'true') return true
  if (trimmed === 'false') return false
  if (trimmed !== '' && /^-?\d+(\.\d+)?([eE][+-]?\d+)?$/.test(trimmed)) {
    const n = Number(trimmed)
    if (Number.isFinite(n)) return n
  }
  return raw
}

export function cmpsForLiveKind(kind: LiveValueKind): readonly ConditionCmp[] {
  return kind === 'number' ? CONDITION_CMPS : EQUALITY_CMPS
}

export function coerceCmpForKind(cmp: ConditionCmp, kind: LiveValueKind): ConditionCmp {
  if (kind === 'number') return cmp
  return EQUALITY_CMPS.includes(cmp) ? cmp : 'eq'
}

export function defaultValueForKind(
  kind: LiveValueKind,
  previous: ConditionScalar
): ConditionScalar {
  if (kind === 'boolean') return typeof previous === 'boolean' ? previous : false
  if (kind === 'string') return typeof previous === 'string' ? previous : String(previous)
  return typeof previous === 'number' && Number.isFinite(previous) ? previous : 0
}
